import { LiveReducerActionType } from "store/reducers/live.reducer";

export const freezeLive = (freeze_live: boolean) => async (dispatch: any) => {
    console.log("Switching freeze live", freeze_live);
    return dispatch({ type: LiveReducerActionType.FREEZE_LIVE, freeze_live });
};
